import React from 'react';

import { Accordion, Box, H2, Separator, Text } from '@betterment/samba-react';

import SimpleAdvisoryFee from './SimpleAdvisoryFee';
import TieredAdvisoryFee from './TieredAdvisoryFee';

import { AdvisorFee } from '../FirmTermsAcceptance/data';

interface Props {
  advisorFee: AdvisorFee;
  firmName: string;
  platformFee: string;
}

const PricingPlan: React.FC<React.PropsWithChildren<Props>> = ({ advisorFee, firmName, platformFee }) => {
  return (
    <Box css={{ mb: 'space.400' }}>
      <H2 variant="title300">Pricing plan</H2>
      <Text
        as="p"
        css={{
          marginBottom: 'space.300',
        }}
      >
        Below is the pricing structure {firmName} uses for its financial advisory services.
      </Text>
      <Box>
        <Box css={{ mb: 'space.200' }}>
          <Text
            as="span"
            css={{
              color: 'text',
              fontWeight: 'bold',
            }}
          >
            Betterment platform fee:
          </Text>
          <Text as="span"> {platformFee} bps</Text>
        </Box>
      </Box>
      <Separator />
      <Box css={{ mt: 'space.150', mb: 'space.300' }}>
        {'tiers' in advisorFee ? (
          <TieredAdvisoryFee tiers={advisorFee.tiers} />
        ) : (
          <SimpleAdvisoryFee rate={advisorFee.rate} />
        )}
      </Box>
      <Box>
        <Accordion type="single" collapsible={true}>
          <Accordion.Item value="services" css={{ border: 'none' }}>
            <Accordion.Trigger css={{ backgroundColor: 'background.neutral', height: 'size.500' }}>
              <Box css={{ p: 'spacing.100' }}>What services are covered in this pricing plan?</Box>
            </Accordion.Trigger>
            <Accordion.Content>
              By making {firmName} your advisor, they will be able to manage your investment accounts at Betterment,
              including modifying your asset allocation, maintaining tax-loss harvesting, and helping you to keep on
              track for your financial goals.
            </Accordion.Content>
          </Accordion.Item>
        </Accordion>
      </Box>
    </Box>
  );
};

export default PricingPlan;
